
<div class="message-box">
	<div class="nf-message" [innerHtml]="statusMessage"></div>
	<!-- <div class="nf-message">{{notificationData.message}}</div> -->
</div>